exports.ALL_PROPERTY_REQUEST = "ALL_PROPERTY_REQUEST"
exports.ALL_PROPERTY_SUCCESS = "ALL_PROPERTY_SUCCESS"
exports.ALL_PROPERTY_FAIL = "ALL_PROPERTY_FAIL"

exports.PROPERTY_DETAILS_REQUEST = "PROPERTY_DETAILS_REQUEST"
exports.PROPERTY_DETAILS_SUCCESS = "PROPERTY_DETAILS_SUCCESS"
exports.PROPERTY_DETAILS_FAIL = "PROPERTY_DETAILS_FAIL"